import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { isBrowser } from '~/utilities/helpers';

import { breakpointNumbers } from '~/theme';

const getScreenSize = () => {
    let sizes = [];
    if (isBrowser()) {
        const { innerWidth } = window;
        if (innerWidth >= breakpointNumbers.largeDesktop) {
            sizes.push('largeDesktop');
        }
        if (innerWidth >= breakpointNumbers.headerBreak) {
            sizes.push('headerBreak');
        }
        if (innerWidth >= breakpointNumbers.desktop) {
            sizes.push('desktop');
        }
        if (innerWidth >= breakpointNumbers.largeTablet) {
            sizes.push('largeTablet');
        }
        if (innerWidth >= breakpointNumbers.tablet) {
            sizes.push('tablet');
        }
        if (innerWidth >= breakpointNumbers.largePhone) {
            sizes.push('largePhone');
        }
        if (innerWidth >= breakpointNumbers.phone) {
            sizes.push('phone');
        }
    }
    return sizes;
};

const useWindowSize = () => {
    const [screenSize, setScreenSize] = useState(getScreenSize());
    useEffect(() => {
        const listener = () => {
            const newSizes = getScreenSize();
            if (!isEqual(newSizes, screenSize)) {
                setScreenSize(newSizes);
            }
        };
        window.addEventListener('resize', listener);

        return () => {
            window.removeEventListener('resize', listener);
        };
    }, [screenSize, setScreenSize]);

    return screenSize;
};

export default useWindowSize;
